// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container___w5jc","image":"style_image___glMp"};